import {
  queryOptions,
  useMutation,
  type useQueryClient,
} from "@tanstack/react-query";
import * as API from "./index";

export const memberQueryFactory = {
  member: "member" as const,
  getMemberList: (params: {
    offset: number;
    count: number;
    sort_by: string | undefined;
    order: "ASC" | "DESC";
    filter: Record<string, string | number> | undefined;
  }) => {
    return queryOptions({
      queryKey: [memberQueryFactory.member, "list", params],
      queryFn: () => API.getMemberList(params),
    });
  },
  getMemberCount: () => {
    return queryOptions({
      queryKey: [memberQueryFactory.member, "count"],
      queryFn: API.getMemberCount,
    });
  },
  getMemberDetail: (id: number) => {
    return queryOptions({
      queryKey: [memberQueryFactory.member, "detail", id],
      queryFn: () => API.getMemberDetail(id),
    });
  },
};

export const memberMutationFactory = {
  checkUniqueCheckinCode: () => {
    return useMutation({
      mutationFn: API.checkUniqueCheckinCode,
    });
  },
  checkUniqueEmail: () => {
    return useMutation({
      mutationFn: API.checkUniqueEmail,
    });
  },
  createMember: () => {
    return (queryClient: ReturnType<typeof useQueryClient>) => {
      return useMutation({
        mutationFn: API.createMember,
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [memberQueryFactory.member, "list"],
          });
          toast.success("Member created successfully");
        },
      });
    };
  },
  updateMemberProfileImage: () => {
    return (queryClient: ReturnType<typeof useQueryClient>) => {
      return useMutation({
        mutationFn: API.updateProfile,
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [memberQueryFactory.member],
          });
          toast.success("Profile image updated successfully");
        },
      });
    };
  },
  updateMember: () => {
    return (queryClient: ReturnType<typeof useQueryClient>) => {
      return useMutation({
        mutationFn: API.updateMember,
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [memberQueryFactory.member],
          });
          toast.success("Member updated successfully");
        },
      });
    };
  },
  deleteMember: () => {
    return (queryClient: ReturnType<typeof useQueryClient>) => {
      return useMutation({
        mutationFn: API.deleteMember,
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [memberQueryFactory.member],
          });
          toast.success("Member deleted successfully");
        },
      });
    };
  },
};
